<template>
  <details :open="node.open">
    <summary class="tree-item">
      {{ node.knowledgeName }}
    </summary>
    <template v-if="childrenList.length">
      <TreeNode
        v-for="(child, index) in childrenList"
        :key="`${node.serialNum}-${child.serialNum}-${index}`"
        :node="child"
      />
    </template>
  </details>
</template>

<script setup>
import { ref, defineProps, computed, watchEffect } from "vue";

const props = defineProps({
  node: {
    type: Object,
    required: true,
  },
  openAllNode: false,
});

// 使用computed确保子节点数据的稳定性
const childrenList = computed(() => {
  return props.node.childrenList || [];
});

// 监听数据变化，确保组件正确更新
watchEffect(() => {
  // 确保子节点数据稳定
  if (childrenList.value.length > 0) {
    // 可以在这里添加额外的数据验证逻辑
  }
});
</script>
<style scoped>
.tree-item {
  min-height: 3rem;
  height: 4rem;
  line-height: 1.3rem;
}
</style>
